import { ArrowUp, ArrowLeft, ArrowRight, ArrowUpLeft, ArrowUpRight, CornerUpLeft, CornerUpRight, RotateCcw, RefreshCw, Flag, Navigation } from "lucide-react";

export const flatM = (a, b) => {
  const x = (b[1] - a[1]) * Math.cos(((a[0] + b[0]) * Math.PI) / 360) * 111320;
  const y = (b[0] - a[0]) * 110540;
  return Math.hypot(x, y);
};

// Nearest route vertex to the current position, searched around the last index first
export function progress(nav, pos, lastIdx = 0) {
  const p = [pos.lat, pos.lon], n = nav.coords.length;
  const scan = (from, to) => {
    let best = -1, bd = Infinity;
    for (let i = Math.max(0, from); i < Math.min(n, to); i++) {
      const d = flatM(p, nav.coords[i]);
      if (d < bd) { bd = d; best = i; }
    }
    return [best, bd];
  };
  let [idx, off] = scan(lastIdx - 30, lastIdx + 400);
  if (off > 1000) [idx, off] = scan(0, n);
  const doneKm = nav.cum_km[idx], totalKm = nav.cum_km[n - 1];
  return { idx, offM: off, doneKm, remKm: Math.max(0, totalKm - doneKm), doneS: nav.cum_s[idx], remS: Math.max(0, nav.cum_s[n - 1] - nav.cum_s[idx]) };
}

export const nextStep = (nav, doneKm) => nav.steps.find((s) => s.km > doneKm + 0.01) || nav.steps[nav.steps.length - 1];

const MOD = {
  left: "sola", right: "sağa", "slight left": "hafif sola", "slight right": "hafif sağa",
  "sharp left": "keskin sola", "sharp right": "keskin sağa", straight: "düz", uturn: "U dönüşü",
};

export function maneuverText(s, t) {
  const mod = t(MOD[s.modifier] || "düz");
  const road = s.name ? ` · ${s.name}` : "";
  switch (s.type) {
    case "arrive": return t("Hedefe varın");
    case "depart": return t("Yola çıkın") + road;
    case "roundabout": case "rotary": case "roundabout turn": case "exit roundabout": case "exit rotary":
      return t("Döner kavşaktan {n}. çıkış", { n: s.exit || 1 }) + road;
    case "merge": return t("Yola katılın") + road;
    case "on ramp": return t("Bağlantı yoluna girin") + road;
    case "off ramp": return t("Çıkışı kullanın ({m})", { m: mod }) + road;
    case "fork": return t("Ayrımda {m} tarafı izleyin", { m: mod }) + road;
    case "end of road": return t("Yol sonunda {m} dönün", { m: mod }) + road;
    case "new name": case "continue": case "notification":
      return (s.modifier && s.modifier !== "straight" ? t("{m} devam edin", { m: mod }) : t("Düz devam edin")) + road;
    default:
      if (s.modifier === "uturn") return t("U dönüşü yapın") + road;
      if (s.modifier === "straight") return t("Düz devam edin") + road;
      return t("{m} dönün", { m: mod }) + road;
  }
}

export function maneuverIcon(s) {
  if (s.type === "arrive") return Flag;
  if (s.type === "depart") return Navigation;
  if (["roundabout", "rotary", "roundabout turn", "exit roundabout", "exit rotary"].includes(s.type)) return RefreshCw;
  return { left: CornerUpLeft, right: CornerUpRight, "sharp left": ArrowLeft, "sharp right": ArrowRight,
    "slight left": ArrowUpLeft, "slight right": ArrowUpRight, uturn: RotateCcw }[s.modifier] || ArrowUp;
}

export const fmtDist = (km) => (km < 1 ? `${Math.round((km * 1000) / 10) * 10} m` : `${km.toFixed(km < 10 ? 1 : 0)} km`);
